import { FC } from "react";

import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

import { mergeSx } from "@/common/helpers/mergeSx";

interface PrizeImageProps {
  photoUrl: string;
  alt: string;
  sx?: SxProps<Theme>;
}

export const PrizeImage: FC<PrizeImageProps> = ({ photoUrl, alt, sx }) => (
  <Box
    component="img"
    src={photoUrl}
    alt={alt}
    loading="lazy"
    sx={mergeSx(
      (theme: Theme) => ({ aspectRatio: "1 / 1", objectFit: "cover", borderRadius: theme.radius(1), display: "block" }),
      sx
    )}
  />
);
